import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TraceMessage } from "./types";

export interface TraceState {
  messages: TraceMessage[];
  traceStarted: boolean;
}

const initialState: TraceState = {
  messages: [],
  traceStarted: false,
};

export const traceSlice = createSlice({
  name: "trace",
  initialState,
  reducers: {
    traceMessageReceived: (state, action: PayloadAction<TraceMessage>) => {
      state.messages.push(action.payload);
    },
    traceResetMessages: (state) => {
      state.messages = [];
    },
    setTraceStarted: (state, action: PayloadAction<boolean>) => {
      state.traceStarted = action.payload;
    },
  },
});

export const { traceMessageReceived, traceResetMessages, setTraceStarted } =
  traceSlice.actions;

export default traceSlice.reducer;
